import { browserLogger } from '@widget/utils/datadog';

import type { ApiResponse } from '@widget/api/types';

interface ZipCodes {
  isCoveredByPartners: boolean; // true if at least one partner is covering the zipcode
  isCoveredByUs: boolean; // Active Coverage
  isCoveredByImmoscout24LessThen12Month: boolean;
  isCoveredByImmoscout24MoreThen12Month: boolean;
  isCoveredByAlpha: boolean;
}

export async function zipCodesApi(zipcode: string): Promise<ZipCodes> {
  try {
    const response = await fetch(`/api-widget/zipcodes/${zipcode}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    const responseParsed: ApiResponse<
      ZipCodes & {
        id: string;
      }
    > = await response.json();
    if (responseParsed.error) {
      throw new Error('Zipcodes api error response');
    }

    return {
      isCoveredByPartners: responseParsed.data.isCoveredByPartners,
      isCoveredByUs: responseParsed.data.isCoveredByUs,
      isCoveredByImmoscout24LessThen12Month:
        responseParsed.data.isCoveredByImmoscout24LessThen12Month,
      isCoveredByImmoscout24MoreThen12Month:
        responseParsed.data.isCoveredByImmoscout24MoreThen12Month,
      isCoveredByAlpha: responseParsed.data.isCoveredByAlpha,
    };
  } catch (e) {
    browserLogger.error(e, 'zipcode fetch error');
    // value by default, if api throws an error
    return {
      isCoveredByPartners: false,
      isCoveredByImmoscout24LessThen12Month: false,
      isCoveredByImmoscout24MoreThen12Month: false,
      isCoveredByAlpha: false,
      isCoveredByUs: true,
    };
  }
}
